import { Component, OnInit, Input } from '@angular/core';
import * as pluginDataLabels from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
  selector: 'app-barchart',
  templateUrl: './barchart.component.html',
  styles: []
})

export class BarchartComponent implements OnInit {

  // Bar Chart
  public barChartOptions: pluginDataLabels.ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{ticks: {min: 0}}] },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };

  @Input() barChartLabels: Label[] = [];
  @Input() barChartData: pluginDataLabels.ChartDataSets[] = [];

  barChartType: pluginDataLabels.ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [pluginDataLabels];
  chartColors: Array<any> = [
    { // all colors in order
      backgroundColor: '#EC3A42'
    },
    { // all colors in order
      backgroundColor: '#9B9B9B'
    }
  ];


  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }
  
  constructor() { }

  ngOnInit() {
  }

}
